import { ConflitoGanttSecao } from "../../../conflito-gantt-secao";
import { ConflitoJustificativa } from "../../../conflito-justificativa";
import { GanttProfissionais } from "@/shared/components/gantt-profissionais";
import { ALOCACAO_SECTION_LABEL } from "../../resolver-conflito.constants";
import styles from "./revisao-step.module.scss";
import type { RevisaoStepViewModel } from "./types-revisao-step";

export function RevisaoStepView({
  papelRotulo,
  profissionalNome,
  substitutoNome,
  obraRotulo,
  notaPapel,
  legenda,
  rows,
  timeline,
  today,
  disabled,
  justificativa,
}: RevisaoStepViewModel) {
  return (
    <>
      <p className={styles.resumo} data-testid="resolver-conflito-revisao-resumo">
        O {papelRotulo} <strong>{profissionalNome}</strong> será substituído por{" "}
        <strong>{substitutoNome}</strong> na <strong>{obraRotulo}</strong>.
      </p>
      <p className={styles.nota} data-testid="resolver-conflito-coordenador-note">
        {notaPapel}
      </p>

      <ConflitoGanttSecao titulo={ALOCACAO_SECTION_LABEL} legenda={legenda}>
        <GanttProfissionais
          rows={rows}
          timeline={timeline}
          today={today}
          headerLabel="Profissional"
        />
      </ConflitoGanttSecao>

      <ConflitoJustificativa
        id="resolver-conflito-justificativa"
        value={justificativa.value}
        onChange={justificativa.alterar}
        error={justificativa.error}
        disabled={disabled}
        divided
        testId="resolver-conflito-justificativa"
        maxLength={justificativa.maxLength}
      />
    </>
  );
}
